// this component holds arbitrary configuration data for a parent component
// i.e. <Shape>
//        <Source x='1' y='2' />
//        <Source x='10' y='24' />
//      </Shape>

const Source = () => null

// to distinguish this component from others
Source.displayName = 'Source'

// helper functions to check if a component is of type "Source"
Source.isSource = (component) => component.type && component.type.displayName === Source.displayName

Source.isNotSource = (component) => !Source.isSource(component)

// helper functions to filter out "Source" or non-"Source" components
Source.filter = (components = []) =>
  components && components.length ? components.filter(Source.isSource) : undefined

Source.reject = (components = []) =>
  components && components.length ? components.filter(Source.isNotSource) : undefined

export default Source
